import { WPAPIPostGraphQL, WPRecentPost } from "@/types";

import { format } from "date-fns";

interface DateRenderPops {
  post: WPRecentPost | WPAPIPostGraphQL;
}

export const DateRender = ({ post }: DateRenderPops) => {
  return (
    <>
      &nbsp;
      {post.node.actual_published_date
        ? format(new Date(post.node.actual_published_date), "dd MMMM yyyy")
        : post.node.date
        ? format(new Date(post.node.date), "dd MMMM yyyy")
        : "Date unavailable"}
    </>
  );
};

export default DateRender;
